<template>
  <!-- BEGIN pos-counter -->
  <div
    class="pos pos-counter ts-overflow-hidden"
    v-bind:class="{ 'pos-mobile-sidebar-toggled': posMobileSidebar }"
    id="pos-counter"
  >
    <!-- BEGIN pos-counter-header -->
    <div class="pos-counter-header">
      <div class="logo">
        <router-link to="/admin/pos/restaurant-sales">
          <div class="logo-img"><img src="@/assets/logo.svg" /></div>
          <div class="logo-text ts-whitespace-no-wrap">
            {{ $t('restaurantSale.pineAndDine') }}
          </div>
        </router-link>
      </div>
      <div class="mb-2 mb-md-0 d-flex ts-whitespace-no-wrap ts-space-x-2">
        <div class="d-flex align-items-center me-3">
          {{ $t('restaurantSale.availableTable') }} ({{
            tableBusy + '/' + totalTable
          }})
        </div>
        <div class="d-flex align-items-center me-3">
          <i class="fa fa-circle fa-fw text-gray-500 ts-mb-1"></i>
          {{ $t('restaurantSale.reserved') }}
        </div>
        <div class="d-flex align-items-center me-3">
          <i class="fa fa-circle fa-fw text-warning ts-mb-1"></i>
          {{ $t('restaurantSale.tableInUse') }}
        </div>
        <div class="d-flex align-items-center me-3">
          <i class="fa fa-circle fa-fw text-theme ts-mb-1"></i>
          {{ $t('restaurantSale.tableAvailable') }}
        </div>
      </div>
      <div class="time" id="time">{{ time }}</div>
      <div class="nav">
        <div v-if="!fullscreen">
          <button
            @click="openFullscreen"
            v-tooltip="'Open Fullscreen'"
            class="nav-link"
          >
            <i class="fas fa-expand fa-2x"></i>
          </button>
        </div>
        <div v-if="fullscreen">
          <button
            @click="closeFullscreen"
            v-tooltip="'Close Fullscreen'"
            class="nav-link"
          >
            <i class="fas fa-compress fa-2x"></i>
          </button>
        </div>
        <b-dropdown variant="link" menu-class="p-b-0">
          <template slot="button-content">
            <span
              :class="`flag-icon flag-icon-${flag} ts-text-lg`"
              :title="flag"
            ></span>
          </template>
          <b-dropdown-item
            href="#"
            v-for="language in languages"
            :key="language.code"
            @click="changeLanguage(language)"
          >
            <span
              :class="`flag-icon flag-icon-${language.icon} ts-text-lg`"
              :title="language.icon"
            ></span>
            {{ language.caption }}
          </b-dropdown-item>
        </b-dropdown>
        <div class="nav-item">
          <router-link
            to="/admin/restaurant-kdu"
            class="nav-link"
            v-tooltip="$t('restaurantSale.kitchenDisplayUnit')"
          >
            <svg
              viewBox="0 0 16 16"
              class="nav-icon"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 0 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8zm5.48-.079V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6zm0 3.75V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141z"
              />
            </svg>
          </router-link>
        </div>
        <div class="nav-item">
          <router-link
            to="/admin/table-bookings"
            v-tooltip="$t('restaurantSale.tableBooking')"
            class="nav-link"
          >
            <svg
              viewBox="0 0 16 16"
              class="nav-icon"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
              />
              <path
                d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"
              />
            </svg>
          </router-link>
        </div>
        <div class="nav-item">
          <router-link to="/" v-tooltip="$t('home')" class="nav-link">
            <i class="fas fa-home fa-2x"></i>
          </router-link>
        </div>
      </div>
    </div>
    <!-- END pos-counter-header -->

    <!-- BEGIN pos-counter-body -->

    <div class="pos-counter-body">
      <!-- BEGIN pos-counter-content -->
      <div class="pos-counter-content">
        <vue-custom-scrollbar class="pos-counter-content-container">
          <ts-loading-banner :loading="tableFetching">
            <div class="table-row">
              <div
                class="table"
                v-for="(table, index) in tableLists"
                :key="index"
                :class="[
                  tableStatus(table),
                  { selected: selected_table == table.table_id }
                ]"
                @click="onTableSelected(table)"
              >
                <!-- <a @click="posMobileSidebarToggled" class="table-container"> -->
                <a class="table-container">
                  <div class="table-status"></div>
                  <div class="table-name">
                    <div class="name">{{ $t('restaurantSale.table') }}</div>
                    <div class="no">{{ table.table_no }}</div>
                    <div class="order">
                      <span v-if="table.num_pax_order_book_status.length < 50">
                        {{ table.num_pax_order_book_status }}
                      </span>
                      <span
                        v-else
                        v-tooltip="table.num_pax_order_book_status"
                        >{{
                          table.num_pax_order_book_status.substring(0, 50) +
                          '..'
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="table-info-row">
                    <div class="table-info-col">
                      <div class="table-info-container">
                        <span class="icon">
                          <i class="far fa-user"></i>
                        </span>
                        <span class="text">{{
                          table.num_customer_status
                        }}</span>
                      </div>
                    </div>
                    <div class="table-info-col">
                      <div class="table-info-container">
                        <span class="icon">
                          <i class="far fa-clock"></i>
                        </span>
                        <span class="text">{{ table.start_time }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="table-info-row">
                    <div class="table-info-col">
                      <div class="table-info-container">
                        <span class="icon">
                          <i class="fa fa-receipt"></i>
                        </span>
                        <span class="text"
                          >{{ defaultCrrency }}
                          {{ table.invoice_amount | format_number }}</span
                        >
                      </div>
                    </div>
                    <div class="table-info-col">
                      <div class="table-info-container">
                        <span class="icon">
                          <i class="fa fa-dollar-sign"></i>
                        </span>
                        <span class="text">{{ table.invoice_status }}</span>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </ts-loading-banner>
        </vue-custom-scrollbar>
      </div>
      <!-- END pos-counter-content -->

      <!-- BEGIN pos-counter-sidebar -->
      <div class="pos-counter-sidebar" id="pos-counter-sidebar">
        <div class="pos-sidebar-header">
          <div class="back-btn">
            <button
              type="button"
              v-on:click="posMobileSidebarToggled"
              class="btn"
            >
              <svg
                viewBox="0 0 16 16"
                class="bi bi-chevron-left"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </button>
          </div>
          <div class="icon"><img src="@/assets/icon-table.svg" /></div>
          <div class="title">
            {{ $t('restaurantSale.table') }} {{ tableSelected.table_no }}
          </div>
          <div class="order">
            {{ $t('restaurantSale.order') }}:
            <b>#{{ tableSelected.order_no }}</b>
          </div>
        </div>
        <div class="pos-sidebar-body">
          <div class="pos-table overflow-auto" data-id="pos-table-info">
            <div
              class="row pos-table-row"
              v-for="(item, index) in orderBy(tableSelected.invoice_detail)"
              :key="index"
            >
              <div class="col-7">
                <div class="pos-product-thumb">
                  <img
                    class="img"
                    v-lazy="{
                      src: productPhoto(item),
                      error: require('@/assets/default-product.jpg'),
                      loading: require('@/assets/Rolling-1s-200px_2.svg')
                    }"
                  />
                  <div class="info">
                    <div class="title">
                      {{
                        item.product_name_kh
                          ? item.product_name_kh
                          : item.product_name_en
                      }}
                    </div>
                    <div class="desc">
                      - {{ $t('restaurantSale.size') }}:
                      {{ item.uom_name_en }} - {{ $t('restaurantSale.price') }}:
                      {{ defaultCrrency }}
                      {{ item.unit_price | format_number }}
                    </div>
                    <div class="desc">
                      - {{ $t('restaurantSale.discount') }}
                      {{
                        item.discount_rate
                          ? '(' + item.discount_rate + '%)'
                          : ''
                      }}:
                      {{ defaultCrrency }}
                      {{ item.discount_amount | format_number }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 total-qty">
                x{{ item.quantity }}
                <br />
                <small
                  class="desc"
                  :class="cookingStatus(item.cooking_status_id)"
                  ><i class="fas fa-mortar-pestle"></i>
                  {{ item.cooking_status }}</small
                >
              </div>
              <div class="col-3 total-price">
                {{ defaultCrrency }}
                {{ item.total_after_discount | format_number }}
                <br />
                <a-popconfirm
                  v-if="item.cooking_status_id == 1"
                  placement="leftTop"
                  :title="$t('are_you_sure_to_delete')"
                  :ok-text="$t('yes')"
                  :cancel-text="$t('no')"
                  @confirm="removeItem(item)"
                >
                  <a href="#" class="btn btn-danger btn-xs">
                    <i class="fa fa-trash"></i>
                  </a>
                </a-popconfirm>
              </div>
            </div>
          </div>
          <div
            class="h-100 d-none align-items-center justify-content-center text-center p-20"
            data-id="pos-table-empty"
          >
            <div>
              <div class="mb-3">
                <svg
                  width="6em"
                  height="6em"
                  viewBox="0 0 16 16"
                  class="text-gray-300"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
                  />
                  <path
                    d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"
                  />
                </svg>
              </div>
              <h4>{{ $t('restaurantSale.noTableSelected') }}</h4>
            </div>
          </div>
        </div>
        <div class="pos-sidebar-footer">
          <div class="subtotal">
            <div class="text">{{ $t('restaurantSale.subtotal') }}</div>
            <div class="price" data-id="price-subtotal">
              {{ defaultCrrency }}
              {{ tableSelected.sub_total | format_number }}
            </div>
          </div>
          <div class="taxes">
            <div class="text">
              VAT {{ vatRate ? '(' + vatRate + '%)' : '' }}
            </div>
            <div class="price">
              {{ defaultCrrency }}
              {{ tableSelected.vat_amount | format_number }}
            </div>
          </div>
          <div class="total">
            <div class="text">{{ $t('restaurantSale.total') }}</div>
            <div class="price" data-id="price-subtotal">
              {{ defaultCrrency }}
              {{ tableSelected.invoice_amount | format_number }}
            </div>
          </div>
          <div class="btn-row">
            <b-dropdown dropdown no-caret>
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item
                :disabled="tableSelected.invoice_status != 'Unpaid'"
                @click.prevent="showCombineTableForm"
              >
                <i class="fas fa-object-ungroup"></i>
                {{ $t('restaurantSale.combineTable') }}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                :disabled="tableSelected.invoice_status != 'Unpaid'"
                @click.prevent="moveTable"
              >
                <i class="fas fa-chalkboard-teacher"></i>
                {{ $t('restaurantSale.moveTable') }}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                @click.prevent="cleanTable"
                :disabled="
                  !tableSelected.table_id ||
                  tableSelected.invoice_status == 'Unpaid'
                "
              >
                <i class="fas fa-chalkboard-teacher"></i>
                {{ $t('restaurantSale.cleanTable') }}
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item
                :disabled="tableSelected.invoice_status != 'Unpaid'"
                @click.prevent="cancelOrder"
              >
              <i class="fas fa-object-ungroup"></i>
                {{ $t('restaurantSale.cancelOrder') }}
              </b-dropdown-item>
            </b-dropdown>
            <ts-button @click.prevent="() => (showForm = true)"
              ><i class="fas fa-user-clock fa-fw fa-lg"></i>
              {{ $t('restaurantSale.shiftClose') }}
            </ts-button>
            <ts-button
              :disabled="tableSelected.invoice_status != 'Unpaid'"
              @click.prevent="addMoreOrder"
              ><i class="fas fa-cart-plus fa-fw fa-lg"></i>
              {{ $t('restaurantSale.add') }}</ts-button
            >
            <ts-button
              :disabled="tableSelected.invoice_status != 'Unpaid'"
              @click.prevent="printBill"
              :waiting="printing"
              color="info"
              ><i v-if="!printing" class="fas fa-file-invoice fa-fw fa-lg"></i>
              {{ $t('restaurantSale.printBill') }}</ts-button
            >
            <ts-button
              :disabled="tableSelected.invoice_status != 'Unpaid'"
              @click.prevent="showBillForm"
              color="success"
              ><i class="fas fa-file-invoice-dollar fa-fw fa-lg"></i>
              {{ $t('restaurantSale.checkBill') }}</ts-button
            >
          </div>
        </div>
      </div>
      <!-- END pos-sidebar -->
    </div>
    <!-- END pos-counter-body -->
    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('restaurantSale.shiftClose')"
      centered
      @cancel="closeForm"
      :zIndex="1020"
      :footer="null"
      width="400px"
    >
      <shift-close @cancel="closeForm" @preview="receiptPreview" />
    </a-modal>
    <a-modal
      v-if="showPreviewReciept"
      v-model="showPreviewReciept"
      :title="$t('restaurantSale.previewReciept')"
      centered
      @cancel="closeForm"
      :zIndex="1020"
      :footer="null"
      width="400px"
    >
      <shift-close @cancel="closeForm" @preview="receiptPreview" />
    </a-modal>
  </div>
  <!-- END pos-counter -->
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import PageOptions from '@/config/PageOptions.vue'
import NumberCustomer from './counter-checkout-components/number-of-customer'
import CombineTable from './counter-checkout-components/combine-table'
import MoveTable from './counter-checkout-components/move-table'
import CheckBill from './counter-checkout-components/check-bill'
import Counter from './counter-checkout-components/counter'
import ShiftClose from './counter-checkout-components/shift-close'
import { mapActions } from 'vuex'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
import { orderBy } from 'lodash'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })
import Reason from './components/reason-delete'
import { Errors } from 'form-backend-validation'

export default {
  components: {
    vueCustomScrollbar,
    ShiftClose
  },
  created () {
    PageOptions.pageEmpty = true
    PageOptions.pageFullHeight = true
    // this.choseCounter()
    this.handleStartTime()
    this.fetchTables()
    this.fetchBefore().finally(() => this.defaultCheckTable(this.table_id))
  },
  mounted () {
    this.interval = setInterval(() => {
      this.fetchTableByInterval()
    }, 30000)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  beforeRouteLeave (to, from, next) {
    PageOptions.pageEmpty = false
    PageOptions.pageFullHeight = false
    next()
  },
  data: function () {
    return {
      model: {
        deleted_reason: null
      },
      counter: {
        counter_id: undefined
      },
      time: '00:00',
      tableFetching: false,
      loading: false,
      printing: false,
      cleaning: false,
      posMobileSidebar: false,
      showForm: false,
      showPreviewReciept: false,
      selected_table: 0,
      tableSelected: {},
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      interval: null,
      fullscreen: false,
      errors: new Errors()
    }
  },
  filters: {
    format_number (value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  computed: {
    tableLists () {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
    },
    table_id () {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
        .table_id
    },
    vatRate () {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate () {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency () {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency () {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .to_currency
    },
    flag () {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    },
    tableBusy () {
      return this.tableLists.filter(t => t.status_id != 1).length
    },
    totalTable () {
      return this.tableLists.length
    }
  },
  methods: {
    ...mapActions('restaurantSale/customerOrder', ['fetchBefore']),
    fetchTableByInterval (attributes) {
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => this.defaultCheckTable(this.tableSelected.table_id))
    },
    fetchTables (attributes) {
      this.tableFetching = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.tableFetching = false))
    },
    cleanTable () {
      this.posMobileSidebar = !this.posMobileSidebar
      this.cleaning = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/cleanTable', this.table_id)
        .then(response => {
          this.laodAndClearTable()
          if (response.message_id == 0) {
            this.$notification['success']({
              message: 'Clean Table',
              description: response.messages,
              placement: 'bottomRight'
            })
          } else {
            this.$notification['warning']({
              message: 'Clean Table',
              description: response.messages,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.$notification['error']({
            message: 'Clean Table',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.cleaning = false))
    },
    moveTable () {
      this.posMobileSidebar = !this.posMobileSidebar
      this.$modal.show(
        MoveTable,
        {
          data: {}
        },
        {
          height: 'auto',
          width: '350px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        }
      )
    },
    tableStatus (table) {
      if (table.status_id == 1) {
        return 'available'
      }
      if (table.status_id == 2) {
        return 'disabled'
      }
      return 'in-use'
    },
    onTableSelected (table) {
      if (table.status_id == 1) {
        this.selected_table = 0
        this.tableSelected = {}
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          {}
        )
        this.showInputNumCustomerForm(table)
      }
      if (table.status_id == 2) {
        this.selected_table = 0
        this.tableSelected = {}
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          {}
        )
        this.showConfirm(table)
      }
      if (table.status_id == 3) {
        this.posMobileSidebar = !this.posMobileSidebar
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          table
        )
        this.tableSelected = table
        this.selected_table = table.table_id
      }
    },
    showInputNumCustomerForm (table) {
      this.$modal.show(
        NumberCustomer,
        {
          data: table
        },
        {
          height: 'auto',
          width: '382px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        }
      )
    },
    cookingStatus (cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    async removeItem (item) {
      await this.$store
        .dispatch('restaurantSale/customerOrder/deleteItemOrdered', item)
        .then(() => {
          this.tableSelected.invoice_detail.splice(
            this.tableSelected.invoice_detail.indexOf(item),
            1
          )
        })
        .catch(error => {
          this.$toasted.error(error.messages)
        })
        .finally(() => {
          this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
            .finally(() => this.defaultCheckTable(this.tableSelected.table_id))
        })
    },
    posMobileSidebarToggled: function () {
      this.posMobileSidebar = !this.posMobileSidebar
    },
    defaultCheckTable (table_id) {
      if (table_id) {
        this.autoSelectedTable(
          this.$store.state.restaurantSale.counterCheckout.tables
            .filter(t => t.table_id == table_id)
            .reduce((init, value) => (init = value), {})
        )
      } else {
        this.autoSelectedTable(
          this.$store.state.restaurantSale.counterCheckout.tables
            .filter(t => t.status_id == 3)
            .reduce((init, value) => (init = value), {})
        )
      }
    },
    autoSelectedTable (table) {
      if (table.status_id == 3) {
        this.$store.commit(
          'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
          table
        )
        this.tableSelected = table
        this.selected_table = table.table_id
      }
    },
    addMoreOrder () {
      this.$router.push({ name: 'customer-order' })
    },
    showCombineTableForm (table) {
      this.posMobileSidebar = !this.posMobileSidebar
      this.$modal.show(
        CombineTable,
        {
          data: table
        },
        {
          height: 'auto',
          width: '100%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: true
        },
        {
          'before-close': this.fetchTables
        }
      )
    },
    productPhoto (item) {
      if (item.photo === null) return ''

      return `/api/files?filePath=${item.photo}`
    },
    showBillForm (table) {
      this.posMobileSidebar = !this.posMobileSidebar
      this.$modal.show(
        CheckBill,
        {
          data: table
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.laodAndClearTable
        }
      )
    },
    laodAndClearTable () {
      this.tableSelected = {}
      this.selected_table = 0
      this.fetchTables()
    },
    handleCheckTime: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? ' PM' : ' AM'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    showConfirm (table) {
      const self = this
      setTimeout(() => {
        this.$confirm({
          title: table.num_pax_order_book_status,
          content: this.$t('restaurantSale.doYouWantToCleanTableAndMakeOrder'),
          onOk () {
            self.isCustomerCome(table)
          },
          okText: 'Yes',
          cancelText: 'No',
          centered: true,
          onCancel () {
            self.$destroyAll()
          }
        })
      }, 500)
    },
    isCustomerCome (table) {
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/isCustomerCome',
          table.booking_id
        )
        .then(() => {
          this.laodAndClearTable()
          this.showInputNumCustomerForm(table)
        })
        .catch(error => {
          this.$notification['error']({
            message: 'Clean Table',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
    },
    choseCounter () {
      if (
        localStorage.getItem('counterId') === undefined ||
        localStorage.getItem('counterId') === null ||
        localStorage.getItem('counterId') === 'undefined' ||
        localStorage.getItem('counterId') === 'null'
      ) {
        if (this.$store.state.authUser.counter.length == 1) {
          localStorage.setItem(
            'counterId',
            this.$store.state.authUser.counter[0].counter_id
          )
          return
        } else {
          this.$confirm({
            centered: true,
            zIndex: 1020,
            title: 'Which counter are you ?',
            content: h =>
              h(Counter, {
                props: {
                  value: this.counter,
                  counter: this.$store.state.authUser.counter
                }
              }),
            onOk: () => {
              localStorage.setItem('counterId', this.counter.counter_id)
              this.$destroyAll()
            },
            onCancel: () => {
              this.$router.push('/')
              this.$destroyAll()
            }
          })
        }
      }
    },
    closeForm () {
      this.showForm = false
    },
    receiptPreview () {
      this.showPreviewReciept = true
    },
    printBill () {
      this.printing = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/printBill', {
          stock_out_id: this.tableSelected.stock_out_id,
          counter_id: localStorage.getItem('counterId'),
          action_type: 'print-bill'
        })
        .then(() => {})
        .catch(error => {
          this.$notification['error']({
            message: 'Print Bill',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.printing = false
        })
    },
    changeLanguage (language) {
      this.$root.$i18n.locale = language.code
    },
    openFullscreen () {
      if (!this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
      }
    },

    closeFullscreen () {
      if (this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    orderBy (items) {
      return orderBy(items, ['display_order'])
    },
    cancelOrder () {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('Are you sure to cancel order?'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('restaurantSale.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
          .dispatch('restaurantSale/counterCheckout/cancelOrder', {
            stock_out_id: this.tableSelected.stock_out_id,
            data: this.model
          })
          .then(response => {
              this.tableFetching = true
              this.$toasted.success(response.messages)
              this.$store
                .dispatch('restaurantSale/counterCheckout/fetchTables')
                .then(() => {
                  this.selected_table = 0
                  this.tableSelected = {}
                  this.$store.commit(
                    'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
                    {}
                  )
                  this.tableFetching = false
                })
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        }
      })
    }
  },
  watch: {
    table_id: function (val) {
      if (val) {
        this.defaultCheckTable(val)
      }
    }
  }
}
</script>
<style scoped>
.pos-counter {
  height: 100vh;
}
@media (max-width: 991.98px) {
  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }
  .pos-counter {
    height: 107vh;
  }
}
</style>
